// client/src/config.js
export const DOMAIN = process.env.REACT_APP_DOMAIN || 'cuet.webfoxx.com';
export const PLATFORM_NAME = 'WebFoxx Academy';
export const PRODUCT_NAME = 'CUET UG & PG';
export const BRAND_TAGLINE = 'CUET UG & PG by WebFoxx Academy';

